import React, { useState } from "react";
import axios from "axios";
import "./css/CustomerSchedule.css";

const BASE_URL = "https://api.dilanaslan.com/api";

// TARİH YARDIMCI FONKSİYONLAR
const formatDateToInput = (date) => {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const getMonday = (date) => {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  const day = d.getDay();

  if (day === 0) {
    d.setDate(d.getDate() - 6);
  } else {
    d.setDate(d.getDate() - (day - 1));
  }

  return d;
};

const CustomerSchedule = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [customerId, setCustomerId] = useState(null);
  const [customerName, setCustomerName] = useState("");
  const [weeklySchedule, setWeeklySchedule] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [currentWeekStart, setCurrentWeekStart] = useState(null);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await axios.get(`${BASE_URL}/customers`, {
        params: { phone: phoneNumber },
      });

      const customers = response.data;

      if (customers.length === 0) {
        setError("Bu telefon numarasına ait müşteri bulunamadı");
        setLoading(false);
        return;
      }

      const customer = customers[0];
      setCustomerId(customer._id);
      setCustomerName(customer.fullName);

      const monday = getMonday(new Date());
      const mondayStr = formatDateToInput(monday);
      setCurrentWeekStart(mondayStr);

      console.log("Müşteri girişi - Pazartesi:", mondayStr);

      await fetchWeeklySchedule(customer._id, mondayStr);
    } catch (err) {
      setError("Bir hata oluştu. Lütfen tekrar deneyin.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchWeeklySchedule = async (custId, weekStart) => {
    try {
      setLoading(true);
      const params = weekStart ? `?weekStart=${weekStart}` : "";
      console.log("Program çekiliyor:", weekStart);
      const response = await axios.get(
        `${BASE_URL}/sessions/weekly/customer/${custId}${params}`
      );
      console.log("Program alındı:", response.data);
      setWeeklySchedule(response.data);
    } catch (err) {
      setError("Ders programı yüklenirken hata oluştu");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handlePrevWeek = () => {
    const current = new Date(currentWeekStart);
    current.setDate(current.getDate() - 7);
    const newWeekStart = formatDateToInput(current);
    console.log("Önceki hafta:", newWeekStart);
    setCurrentWeekStart(newWeekStart);
    fetchWeeklySchedule(customerId, newWeekStart);
  };

  const handleNextWeek = () => {
    const current = new Date(currentWeekStart);
    current.setDate(current.getDate() + 7);
    const newWeekStart = formatDateToInput(current);
    console.log("Sonraki hafta:", newWeekStart);
    setCurrentWeekStart(newWeekStart);
    fetchWeeklySchedule(customerId, newWeekStart);
  };

  const handleLogout = () => {
    setCustomerId(null);
    setCustomerName("");
    setPhoneNumber("");
    setWeeklySchedule(null);
    setCurrentWeekStart(null);
    setError("");
  };

  if (!customerId) {
    return (
      <div className="customer-schedule-container">
        <div className="login-card">
          <div className="logo-section">
            <h1>Dilan Aslan</h1>
            <p>Çocuk Gelişim Danışmanlığı</p>
          </div>

          <form onSubmit={handleLogin} className="login-form">
            <h2>Ders Programını Görüntüle</h2>
            <p className="login-description">
              Haftalık ders programınızı görüntülemek için telefon numaranızı
              girin
            </p>

            {error && <div className="error-message">{error}</div>}

            <div className="form-group">
              <label htmlFor="phone">Telefon Numarası</label>
              <input
                id="phone"
                type="tel"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                placeholder="5051234567"
                required
                maxLength="10"
                pattern="[0-9]{10}"
              />
              <small>Örnek: 5051234567 (0 olmadan)</small>
            </div>

            <button type="submit" className="btn-login" disabled={loading}>
              {loading ? "Yükleniyor..." : "Programı Görüntüle"}
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="customer-schedule-container">
      <div className="schedule-content">
        <div className="schedule-header">
          <div className="header-left">
            <h1>Hoş Geldiniz, {customerName}</h1>
            <p>Haftalık Ders Programınız</p>
          </div>
          <button onClick={handleLogout} className="btn-logout">
            Çıkış
          </button>
        </div>

        {weeklySchedule && weeklySchedule.days && (
          <>
            <div className="week-navigation">
              <button
                onClick={handlePrevWeek}
                className="nav-btn"
                disabled={loading}
              >
                ← Önceki Hafta
              </button>
              <div className="week-range">
                {weeklySchedule.days.length > 0 && (
                  <>
                    {weeklySchedule.days[0].dayName}{" "}
                    {weeklySchedule.days[0].date} -{" "}
                    {weeklySchedule.days[6].dayName}{" "}
                    {weeklySchedule.days[6].date}
                  </>
                )}
              </div>
              <button
                onClick={handleNextWeek}
                className="nav-btn"
                disabled={loading}
              >
                Sonraki Hafta →
              </button>
            </div>

            <div className="days-grid">
              {weeklySchedule.days.map((day, index) => {
                const hasLessons = day.sessions && day.sessions.length > 0;
                return (
                  <div
                    key={index}
                    className={`day-item ${
                      hasLessons ? "has-lessons" : "no-lessons"
                    }`}
                  >
                    <div className="day-name">{day.dayName}</div>
                    <div className="day-date">{day.date}</div>

                    {hasLessons ? (
                      <div className="lessons-list">
                        {day.sessions.map((session) => {
                          const sessionDate = new Date(session.sessionDate);
                          const hours = String(sessionDate.getHours()).padStart(
                            2,
                            "0"
                          );
                          const minutes = String(
                            sessionDate.getMinutes()
                          ).padStart(2, "0");
                          const timeStr = `${hours}:${minutes}`;

                          return (
                            <div key={session._id} className="lesson-item">
                              <div className="lesson-time">{timeStr}</div>
                              <div className="lesson-info">
                                <div className="lesson-child">
                                  {session.childId?.name}
                                </div>
                                <div className="lesson-type">
                                  {session.sessionType}
                                </div>
                                <div className="lesson-duration">
                                  {session.duration} dakika
                                </div>
                                {session.customerPackageId && (
                                  <div className="lesson-package">
                                    📦 {session.customerPackageId.packageName}
                                    <span className="package-remaining">
                                      {session.customerPackageId.remainingSessions} seans kaldı
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div className="no-lesson-text">Ders Yok</div>
                    )}
                  </div>
                );
              })}
            </div>
          </>
        )}

        {loading && (
          <div className="loading-overlay">
            <div className="spinner"></div>
            <p>Yükleniyor...</p>
          </div>
        )}
      </div>

      <div className="footer-info">
        <p>Dilan Aslan Çocuk Gelişim Danışmanlığı</p>
        <p>📞 +90 505 551 77 47</p>
        <p>
          📍 13 Mart Mah. 15 Temmuz Şehitler Cad. Konak Apt No:6 İç Kapı No:8
          Artuklu/Mardin
        </p>
      </div>
    </div>
  );
};

export default CustomerSchedule;
